import { render } from "./UserDelete.vue?vue&type=template&id=0337f77a"
import script from "./UserDelete.vue?vue&type=script&lang=js"
export * from "./UserDelete.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__